import PropTypes from 'prop-types';
import React from 'react';
import { Flex, Icon, NakedButton, Text } from 'roo-ui/components';

const CollapsedMessaging = ({ onToggleMenu }) => {
  return (
    <Flex height="100%" alignItems="center">
      <Icon name="chevronRight" color="greys.steel" size={22} mr={4} mt={1} />
      <Text display="block" fontSize="base" data-testid="discounts-and-deals-text">
        Book an escape with these great discounts & deals
      </Text>
      <Text display="block" fontSize="base" mx={4}>
        |
      </Text>
      <NakedButton color="brand.primary" onClick={onToggleMenu}>
        <Text display="block" fontSize="base">
          View deals
        </Text>
      </NakedButton>
    </Flex>
  );
};

CollapsedMessaging.propTypes = {
  onToggleMenu: PropTypes.func.isRequired,
};

export default CollapsedMessaging;
